import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["icon"];
  static values = {
    value: String,
    defaultClasses: { type: String, default: "" },
    selectedClasses: { type: String, default: "" },
    disabledClasses: { type: String, default: "" }
  };

  toggle(event) {
    const button = this.element;
    if (button.disabled) return;
    const isActive = button.classList.toggle('active');

    // Toggle icon visibility if we have an icon target
    if (this.hasIconTarget) {
      this.iconTarget.classList.toggle('d-none', !isActive);
    } else {
      // Legacy support for non-targeted icons
      const iconElement = button.querySelector('i');
      if (iconElement) {
        iconElement.style.display = isActive ? '' : 'none';
      }
    }

    if (isActive) {
      this._removeClasses(button, this.defaultClassesValue.split(" ").filter(Boolean));
      this._addClasses(button, this.selectedClassesValue.split(" ").filter(Boolean));
    } else {
      this._removeClasses(button, this.selectedClassesValue.split(" ").filter(Boolean));
      this._addClasses(button, this.defaultClassesValue.split(" ").filter(Boolean));
    }
    
    // Dispatch an event so parent controllers can react
    if (this.hasValueValue || this.hasCategoryValue) {
      this.element.dispatchEvent(
        new CustomEvent("selectButtonToggled", {
          bubbles: true,
          detail: {
            value: this.hasValueValue ? this.valueValue : null,
            category: this.hasCategoryValue ? this.categoryValue : null,
            active: isActive
          }
        })
      );
    }
  }

  connect() {
    const button = this.element;
    const isActive = button.classList.contains('active');
    
    // Set initial icon visibility
    if (this.hasIconTarget) {
      this.iconTarget.classList.toggle('d-none', !isActive);
    } else {
      // Legacy support for non-targeted icons
      const iconElement = button.querySelector('i');
      if (iconElement) {
        iconElement.style.display = isActive ? '' : 'none';
      }
    }

    if (button.disabled) {
      this._removeClasses(button, [
        ...this.defaultClassesValue.split(" ").filter(Boolean),
        ...this.selectedClassesValue.split(" ").filter(Boolean)
      ]);
      this._addClasses(button, this.disabledClassesValue.split(" ").filter(Boolean));
    } else if (isActive) {
      this._removeClasses(button, [
        ...this.defaultClassesValue.split(" ").filter(Boolean),
        ...this.disabledClassesValue.split(" ").filter(Boolean)
      ]);
      this._addClasses(button, this.selectedClassesValue.split(" ").filter(Boolean));
    } else {
      this._removeClasses(button, [
        ...this.selectedClassesValue.split(" ").filter(Boolean),
        ...this.disabledClassesValue.split(" ").filter(Boolean)
      ]);
      this._addClasses(button, this.defaultClassesValue.split(" ").filter(Boolean));
    }
  }

  _addClasses(element, classes) {
    classes.forEach(cls => element.classList.add(cls));
  }

  _removeClasses(element, classes) {
    classes.forEach(cls => element.classList.remove(cls));
  }
}
